import * as React from 'react';
import Svg, {Circle, Path, Defs, LinearGradient, Stop} from 'react-native-svg';
import Settings from 'src/Settings';
type ReferralRewardProps = {
  width?: number;
  color?: string;
  height?: number;
  style?: {[index: string]: {[index: string]: number | string}};
  opacity?: number;
  fillColor?: string;
};
export default class Referral extends React.Component<ReferralRewardProps> {
  render() {
    return (
      <>
        {Settings.isCanteenWeb() ? (
          <Svg
            width={this.props.width}
            height={this.props.height}
            viewBox="0 0 50 51"
            fill="none"
          >
            <Path
              d="M0 25.5C0 11.693 11.193.5 25 .5s25 11.193 25 25-11.193 25-25 25-25-11.193-25-25z"
              fill="#003349"
              fillOpacity={0.2}
            />
            <Path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M32.107 29.26a3.01 3.01 0 00-2.872 3.913l-.82.258A3.87 3.87 0 0134.175 29l.512-.513.344.344v1.548h-1.548l-.344-.344.408-.408a2.995 2.995 0 00-1.44-.366zm3.01 3.01a3 3 0 00-.137-.903l.82-.258a3.87 3.87 0 01-5.76 4.432l-.512.513-.344-.344v-1.548h1.548l.344.344-.408.408a3.01 3.01 0 004.45-2.644zm-3.525-1.548h.172v-.516h.688v.516h.172c.38 0 .688.308.688.688v.172h-.688v-.172h-1.032v.32l1.167.233a.688.688 0 01.553.675v.492c0 .38-.308.688-.688.688h-.172v.516h-.688v-.516h-.172a.688.688 0 01-.688-.688v-.172h.688v.172h1.032v-.492l-1.167-.233a.688.688 0 01-.553-.675v-.32c0-.38.308-.688.688-.688z"
              fill="#003349"
            />
            <Path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M25.308 15.174a5.226 5.226 0 100 10.452 5.226 5.226 0 000-10.452zM24.68 26.66c-3.647 0-7.077.929-10.054 2.56l-.575.312v5.105h13.442l-.183-1.648c-.122-1.097.092-2.215.66-3.161a5.055 5.055 0 011.655-1.685l.49-.306c-.948-.388-3.447-1.179-5.435-1.177z"
              fill="#003349"
            />
          </Svg>
        ) : Settings.is365Pay() || Settings.isAramark() ? (
          <Svg
            width={this.props.width}
            height={this.props.height}
            viewBox="0 0 50 51"
            fill="none"
          >
            <Path
              d="M0 25.5C0 11.693 11.193.5 25 .5s25 11.193 25 25-11.193 25-25 25-25-11.193-25-25z"
              fill={this.props.color ?? '#066DFF'}
            />
            <Path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M32.107 29.26a3.01 3.01 0 00-2.872 3.913l-.82.258A3.87 3.87 0 0134.175 29l.512-.513.344.344v1.548h-1.548l-.344-.344.408-.408a2.995 2.995 0 00-1.44-.366zm3.01 3.01a3 3 0 00-.137-.903l.82-.258a3.87 3.87 0 01-5.76 4.432l-.512.513-.344-.344v-1.548h1.548l.344.344-.408.408a3.01 3.01 0 004.45-2.644zm-3.525-1.548h.172v-.516h.688v.516h.172c.38 0 .688.308.688.688v.172h-.688v-.172h-1.032v.32l1.167.233a.688.688 0 01.553.675v.492c0 .38-.308.688-.688.688h-.172v.516h-.688v-.516h-.172a.688.688 0 01-.688-.688v-.172h.688v.172h1.032v-.492l-1.167-.233a.688.688 0 01-.553-.675v-.32c0-.38.308-.688.688-.688z"
              fill={this.props.fillColor ?? '#FEE0E6'}
            />
            <Path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M25.308 15.174a5.226 5.226 0 100 10.452 5.226 5.226 0 000-10.452zM24.68 26.66c-3.647 0-7.077.929-10.054 2.56l-.575.312v5.105h13.442l-.183-1.648c-.122-1.097.092-2.215.66-3.161a5.055 5.055 0 011.655-1.685l.49-.306c-.948-.388-3.447-1.179-5.435-1.177z"
              fill={this.props.fillColor ?? '#FEE0E6'}
            />
          </Svg>
        ) : (
          <Svg
            width={this.props.width}
            height={this.props.height}
            viewBox="0 0 40 40"
            fill="none"
          >
            <Circle
              cx={20}
              cy={20}
              r={20}
              fill={this.props.color ?? '#003349'}
              fillOpacity={this.props.opacity ?? 0.2}
            />
            <Path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M25.585 22.955a2.365 2.365 0 00-2.257 3.074l-.645.203a3.04 3.04 0 014.526-3.483l.403-.402.27.27v1.216h-1.216l-.27-.27.32-.32a2.353 2.353 0 00-1.132-.288zm2.365 2.365c0-.248-.038-.486-.108-.71l.644-.203a3.04 3.04 0 01-4.526 3.483l-.402.403-.27-.27v-1.217h1.216l.27.27-.32.32a2.365 2.365 0 003.497-2.078l-.001.002zm-2.77-1.216h.135v-.406h.54v.405h.136a.54.54 0 01.54.54v.136h-.54v-.135h-.811v.252l.917.183a.54.54 0 01.434.53v.386a.54.54 0 01-.54.54h-.136v.407h-.54v-.406h-.136a.54.54 0 01-.54-.54v-.136h.54v.136h.811v-.387l-.916-.183a.54.54 0 01-.435-.53v-.252a.54.54 0 01.54-.54z"
              fill="url(#paint0_linear_9880_40977)"
            />
            <Path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M20.242 11.887a4.106 4.106 0 100 8.212 4.106 4.106 0 000-8.212zm-.494 9.024c-2.866 0-5.56.73-7.9 2.011l-.452.246v4.01h10.562l-.144-1.294a3.97 3.97 0 01.52-2.484c.317-.529.76-.985 1.3-1.323l.384-.24c-.744-.306-2.708-.927-4.27-.925z"
              fill="url(#paint1_linear_9880_40977)"
            />
            <Defs>
              <LinearGradient
                id="paint0_linear_9880_40977"
                x1={18.5}
                y1={18.9467}
                x2={27.3597}
                y2={26.9158}
                gradientUnits="userSpaceOnUse"
              >
                <Stop offset={0.28} stopColor={this.props.color ?? '#003349'} />
                <Stop offset={0.92} stopColor={this.props.color ?? '#003349'} />
                <Stop offset={1} stopColor={this.props.color ?? '#003349'} />
              </LinearGradient>
              <LinearGradient
                id="paint1_linear_9880_40977"
                x1={11.3543}
                y1={15.1717}
                x2={27.2456}
                y2={28.4707}
                gradientUnits="userSpaceOnUse"
              >
                <Stop offset={0.16} stopColor={this.props.color ?? '#003349'} />
                <Stop offset={1} stopColor={this.props.color ?? '#003349'} />
              </LinearGradient>
            </Defs>
          </Svg>
        )}
      </>
    );
  }
}
